import React from 'react';
import Grid from '@mui/material/Grid';
import EstrategiasComunicacion2025 from '../../components/LandingPage/LiderazgoMinisterio/EstrategiasComunicacion2025';

export const EstrategiasComunicacion2025Page = () => {
  return (
    <>
      <Grid container className='landing-container'>
        <Grid item xs={12}>
          <EstrategiasComunicacion2025 />
        </Grid>
      </Grid>
    </>
  );
};

export default EstrategiasComunicacion2025Page;




